export default __webpack_public_path__ + "static/media/analytics.86fabf83.svg";